import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import Modal from 'react-modal';
import styles from './ClientInfo.module.scss';
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import TextField from "../../../../components/FormElements/TextField";
import { CustomSingleDatePicker } from "../../../../components/CustomDatePicker/CustomDatePicker";
import clientsApi from "../../../../store/clientsStore/clientsApi";
import { convertDate, convertDateYToString } from "../../../../tools/convertDateToString";
import { PENDING } from "../../../../store/globalStatuses/globalStatuses";
import { PhoneInputField } from "../../../../components/PhoneInput";
import { useCurrentBranch } from "../../../../hooks/useCurrentBranch";

const nameConfirmModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '450px',
        width: '90%',
        borderRadius: '12px',
        padding: '24px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    }
};

export default function ClientInfo(props) {
    const { t } = useTranslation();
    const {
        customer,
        getBackToClients,
        info,
    } = props
    const { id } = useParams()
    const history = useHistory();
    const { customer: customerInfo, cStatus } = useSelector(s => s.clientInfoReducer);
    const { currentBranch } = useCurrentBranch();
    const branchInfo = useSelector(s => s.branchReducer?.info);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [birthday, setBirthday] = useState(null);
    const [pending, setPending] = useState(null);
    const [deleting, setDeleting] = useState(null);
    const [nameConfirmModal, setNameConfirmModal] = useState(null);
    const query = useLocation();
    const searchParams = new URLSearchParams(query.search);

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    useEffect(() => {
        if (customerInfo) {
            setFirstName(customerInfo.first_name || "");
            setLastName(customerInfo.last_name || "");
            setPhoneNumber(customerInfo.phone || "");
            let d = null;
            if (customerInfo.birthday) {
                const splitted = customerInfo.birthday.split("-");
                d = `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
            }
            if (isValidDate(new Date(d))) {
                setBirthday(d);
            } else {
                setBirthday(null);
            }
        }
    }, [customerInfo]);

    const buildPayload = (forceNameUpdate = false) => {
        let newB = null;
        if (birthday) {
            newB = convertDate(birthday).split('.').join('-')
        }
        const branchId = currentBranch?.id || branchInfo?.id;
        return {
            first_name: firstName,
            last_name: lastName,
            birthday: newB,
            new_phone_number: phoneNumber,
            force_name_update: forceNameUpdate,
            branch_id: branchId,
        };
    };

    const handleSaveResponse = (res) => {
        if (res && res.code === 4001 && res.message === 'name_change_confirmation_required') {
            setNameConfirmModal(res.data);
            setPending(false);
            return;
        }
        if (searchParams.get("from") === "transaction" && searchParams.get("transactionId")) {
            return history.push(`/?transactionId=${searchParams.get("transactionId")}`);
        } else {
            history.goBack();
        }
    };

    const save = (forceNameUpdate = false) => {
        setPending(true);
        if (customerInfo) {
            clientsApi.putClient(customerInfo.id, buildPayload(forceNameUpdate))
              .then(handleSaveResponse)
              .finally(() => {
                  setPending(false);
              })
        }
    }

    const handleForceNameUpdate = () => {
        setNameConfirmModal(null);
        save(true);
    };

    const handleDelete = () => {
        setDeleting(true);
        if (customerInfo) {
            clientsApi.deleteClient(info.id, customerInfo.id)
                .then(() => {
                    if (searchParams.get("from") === "transaction" && searchParams.get("transactionId")) {
                        return history.push(`/?transactionId=${searchParams.get("transactionId")}`);
                    } else if (searchParams.get("from") === "database") {
                        return history.push('/clients-database');
                    } else {
                        history.push("/clients");
                    }
                })
                .finally(() => {
                    setDeleting(false);
                })
        }
    }


    const onClickBack = () => {
        if (searchParams.get("from") === "transaction" && searchParams.get("transactionId")) {
            return history.push(`/?transactionId=${searchParams.get("transactionId")}`);
        }
        history.goBack();
    }

    return (
        <div className={styles.container}>
            <i className="fa fa-chevron-left" aria-hidden="true"
               style={{position: "absolute", left: 34, top: 54, cursor: 'pointer'}}
               onClick={onClickBack}/>
            <form className={styles.form}>
                <div className={styles.formInner}>
                    <TextField
                      label={t('Form.firstName')}
                      placeholder={t('Form.enterFirstName')}
                      disabled={pending || cStatus === PENDING}
                      // required

                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    <TextField
                      label={t('Form.lastName')}
                      placeholder={t('Form.enterLastName')}
                      disabled={pending || cStatus === PENDING}
                      // required

                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    <div style={{ width: '234px', marginTop: '19px' }}>
                        <PhoneInputField
                          value={phoneNumber}
                          pending={pending || cStatus === PENDING}
                          onChange={(v) => setPhoneNumber(v)}
                          label={t('NSAuth.phone')}
                          placeholder={t('newPhone')}
                        />
                    </div>

                    <div style={{ width: '238px', marginTop: '19px' }}>
                        <p>{t("NSBonus.birthday")}</p>
                        <CustomSingleDatePicker
                          tSetDate={(value) => setBirthday(value)}
                          tDate={birthday}
                          maxDate={new Date(Date.now())}
                        />
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 30, gap: 16}}>
                    <ButtonFilled
                      variant="green"
                      onClick={() => save(false)}
                      loading={pending || cStatus === PENDING}
                    >
                        {t('save')}
                    </ButtonFilled>
                    <ButtonFilled
                        variant="red"
                        onClick={handleDelete}
                        loading={pending || cStatus === PENDING || deleting}
                    >
                        {t('delete')}
                    </ButtonFilled>
                </div>
            </form>

            <Modal
                isOpen={!!nameConfirmModal}
                onRequestClose={() => setNameConfirmModal(null)}
                style={nameConfirmModalStyles}
                ariaHideApp={false}
            >
                {nameConfirmModal && (
                    <div>
                        <h3 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600 }}>
                            {t('clientEdit.nameChangeWarningTitle') || 'Подтверждение изменения имени'}
                        </h3>
                        <p style={{ margin: '0 0 12px', fontSize: '14px', color: '#666' }}>
                            {t('clientEdit.nameChangeWarningText') || 'У клиента уже заполнены имя и фамилия. Вы уверены что хотите их изменить?'}
                        </p>
                        <div style={{
                            background: '#f5f5f5',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            fontSize: '14px',
                        }}>
                            <div style={{ marginBottom: '8px' }}>
                                <strong>{t('clientEdit.currentName') || 'Текущие значения'}:</strong>
                                <br />
                                {nameConfirmModal.current_first_name} {nameConfirmModal.current_last_name}
                            </div>
                            <div>
                                <strong>{t('clientEdit.newName') || 'Новые значения'}:</strong>
                                <br />
                                {nameConfirmModal.new_first_name} {nameConfirmModal.new_last_name}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <ButtonFilled
                                variant="grey"
                                onClick={() => setNameConfirmModal(null)}
                            >
                                {t('cancel') || 'Отмена'}
                            </ButtonFilled>
                            <ButtonFilled
                                variant="green"
                                onClick={handleForceNameUpdate}
                                loading={pending}
                            >
                                {t('clientEdit.confirmNameChange') || 'Да, изменить'}
                            </ButtonFilled>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    )
}
